import { useLocation } from 'react-router';
import usePush from './usePush';

const usePushLocationSearch = () => {
  const pushPath = usePush();
  const location = useLocation();

  const pushLocationSearch = path => {
    pushPath(location.search ? `${path}${location.search}` : path);
  };

  return pushLocationSearch;
};

export default usePushLocationSearch;
